import { render, staticRenderFns } from "./HandleCreateCustomStocktake.vue?vue&type=template&id=20d5a10b&scoped=true&"
import script from "./HandleCreateCustomStocktake.vue?vue&type=script&lang=js&"
export * from "./HandleCreateCustomStocktake.vue?vue&type=script&lang=js&"
import style0 from "./HandleCreateCustomStocktake.vue?vue&type=style&index=0&id=20d5a10b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5a10b",
  null
  
)

export default component.exports